import { useEffect, useRef } from "react";
import { CustomModal, Typography } from "get-life-storybook-ts";
import { ButtonsModalI } from "get-life-storybook-ts/lib/organisms/Modal/CustomModal";
import { customWeCallYouStyles } from "../../constants/CustomStyles/WeCallYou";

interface PendingCapitalAdjustmentModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  acceptLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

interface ModalPortalHandle {
  handleShowPortal: () => void;
  handleClosePortal: () => void;
}

const PendingCapitalAdjustmentModal = ({
  isOpen,
  title,
  message,
  acceptLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}: PendingCapitalAdjustmentModalProps) => {
  const modalRef = useRef<ModalPortalHandle | null>(null);
  const wasOpenRef = useRef(false);

  useEffect(() => {
    if (isOpen && !wasOpenRef.current) {
      modalRef.current?.handleShowPortal();
      wasOpenRef.current = true;
    } else if (!isOpen && wasOpenRef.current) {
      modalRef.current?.handleClosePortal();
      wasOpenRef.current = false;
    }
  }, [isOpen]);

  const ModalTitle = (
    <Typography
      variant={customWeCallYouStyles.titleVariant}
      weight={customWeCallYouStyles.titleWeight}
      text={title}
    />
  );

  const ModalBody = (
    <Typography
      variant={customWeCallYouStyles.bodyTextVariant}
      weight={customWeCallYouStyles.bodyTextWeight}
      text={message}
    />
  );

  const ModalActions: ButtonsModalI = {
    showBoth: true,
    preventClose: true,
    buttonInfo: {
      primary: {
        label: acceptLabel,
        onClick: () => {
          modalRef.current?.handleClosePortal();
          wasOpenRef.current = false;
          onConfirm();
        },
      },
      secondary: {
        label: cancelLabel,
        onClick: () => {
          modalRef.current?.handleClosePortal();
          wasOpenRef.current = false;
          onCancel();
        },
      },
    },
  };

  return (
    <CustomModal
      ref={modalRef}
      ModalTitle={ModalTitle}
      ModalBody={ModalBody}
      ModalActions={ModalActions}
      closeModalCallback={() => {
        wasOpenRef.current = false;
        onCancel();
      }}
    />
  );
};

export default PendingCapitalAdjustmentModal;
